import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=14362196&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=14362196&prod&lang=css"
import style1 from "./Main.vue?vue&type=style&index=1&id=14362196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14362196",
  null
  
)

export default component.exports